import React from 'react'
import cls from '@UI/crypto_exchange/desktop/components/modals/ProblemGamblerModal/ProblemGamblerModal.module.scss'
import { formatTimeString } from '@App/helpers/time'
import { useAppDispatch } from '@App/hooks'
import { asyncLogout } from '@Redux/slices/user/UserSlice'

interface Props {
  closeModal: () => void
  timeLoc?: number
  params: any
  changeStep: any
}

const StepExclude: React.FC<Props> = ({ params, closeModal }) => {
  const dispatch = useAppDispatch()

  const renderTriggers = (triggers: any) => {
    const content = triggers.map((trigger: any, key: any) => {
      return (
        <div key={key}>
          {formatTimeString(trigger.date)} - <b>{trigger.title} {...trigger.title_params}</b>
        </div>
      )
    })

    return <div className="req-doc-modal__triggers">{content}</div>
  }

  const getRegretMessageByExcludePeriod = (period: string) => {
    switch (period) {
      case '1':
        return `account__problem_gambler_regret_24h ${getEndExcludeDate()}`
      case '2':
        return `account__problem_gambler_regret_48h ${getEndExcludeDate()}`
      case '7':
        return `account__problem_gambler_regret_7d ${getEndExcludeDate()}`
      case 'completely':
        return 'account__problem_gambler_regret_completely'
    }
  }

  const getEndExcludeDate = () => {
    const exclude_end = params?.exclude_end
    if (!exclude_end || exclude_end === 'completely') {
      return null
    }

    return formatTimeString(exclude_end, 'MMM d, HH:mm')
  }

  const triggers = params?.triggers ?? []
  const period = params?.exclude_period ?? null

  return (
    <div className={`${cls.step} ${cls.exclude}`}>
      <div className={cls.modalHeader}>
        <div className={cls.title}>account__problem_gambler_exclude_title</div>
      </div>
      <div className={cls.textExclude}>
        <div className="req-doc-modal__description">
          {'account__problem_gambler_exclude_first_description'} {triggers?.length}
        </div>
        {triggers ? renderTriggers(triggers) : null}
        <div className="req-doc-modal__text">{'account__problem_gambler_exclude_second_description'}</div>
        <div className="req-doc-modal__text">{getRegretMessageByExcludePeriod(period)}</div>
        <div
          className="req-doc-modal__text"
          dangerouslySetInnerHTML={{ __html: 'account__problem_gambler_exclude_third_description' }}
        />
      </div>
      <button
        className={cls.button}
        onClick={() => {
          dispatch(asyncLogout())
          closeModal()
        }}
      >
        Continue
      </button>
    </div>
  )
}

export default StepExclude
